<script>
import { menuItemsByPrivileges } from "@/utils/menus.js";
import {getAllSupplier} from '@/services/supplier-api';
import {setSimulatedSupplier} from '@/services/admin-api';
import { mapGetters } from "vuex";
import { hasExactRole, ROLES } from "@/utils/permissions";
import SuppliersTable from '@/components/tables/SuppliersTable.vue';
import { clearAuthData } from '@/utilsAuth';


export default {
  components: { SuppliersTable },

  name: "HeaderScreen",
  data() {
    return {
      menuItems: [],
      mainPageModel:{page:1, pageSize:10},
      userFullName: this.getCookie("ufn") || "Utilisateur",
      isMenuOpen: false,
      name: null,
      supplierList:[],
      supplierListIsBusy:false,
      showSupplierModal:false,

    };
  },

  mounted() {
    this.loadMenu();

    if(this.isAdmin){
      this.findAllSupplier();
    }
  },

  computed: {
    ...mapGetters(["simulatedSupplier"]),

    isAdmin() {
      return hasExactRole(ROLES.ADMIN);
    },
  },

  methods: {

    async handleSetSimulatedSupplier(supplier, options = {}) {
      const shouldNavigate = options.navigate !== false;
      const currentSupplierId = this.simulatedSupplier?.id;

      if (!supplier?.id || String(currentSupplierId) === String(supplier.id)) {
        this.showSupplierModal = false;
        return;
      }

      await this.saveSimulatedSupplier(supplier.id)
      await this.$store.dispatch("setSimulatedSupplier", supplier);
      this.showSupplierModal = false;

      if (shouldNavigate) {
        await this.refreshPlatform();
      }
    },

    onPageChange(newPage) {
      this.mainPageModel.page = newPage;
      this.findAllSupplier();
    },

    onPageSizeChange(newPageSize) {
      this.mainPageModel.pageSize = newPageSize;
      this.mainPageModel.page = 1;
      this.findAllSupplier();
    },

    openSupplierModal() {
      this.showSupplierModal = true;
    },

    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },

    getCookie(name) {
      const cookies = document.cookie.split("; ");
      for (let cookie of cookies) {
        const [cookieName, cookieValue] = cookie.split("=");
        if (cookieName === name) {
          return decodeURIComponent(cookieValue);
        }
      }
      return null;
    },

    loadMenu() {
      this.menuItems = menuItemsByPrivileges(this.userPrivilege);
    },

    goToProfile() {
      this.$router.push("/profile");
    },

    async logout() {
      await clearAuthData();
      this.$router.push("/login");
    },

    // API CALL //

    async findAllSupplier(){

      this.supplierListIsBusy = true
      const params = {
        page: this.mainPageModel.page,
        pageSize: this.mainPageModel.pageSize,
        name:this.name,
      };

      const response = await getAllSupplier(params);
      this.supplierList = response.content;
      this.mainPageModel.total = response.totalElements;
      this.mainPageModel.totalPages = response.totalPages;
      this.mainPageModel.page = response.pageNumber;
      this.supplierListIsBusy = false

      ///set Default Supplier
      if(this.supplierList && this.supplierList.length && (this.simulatedSupplier == null || this.simulatedSupplier.id == null || this.simulatedSupplier.id == "undefined")){
        this.handleSetSimulatedSupplier(this.supplierList[0], { navigate: false })
      }

    },
    

    async saveSimulatedSupplier(supplierId){

      const params = {
        supplierId: supplierId
      }

      await setSimulatedSupplier(params)
    },

    async refreshPlatform() {
      if (this.$route.path !== "/dashboard") {
        await this.$router.replace("/dashboard").catch(() => {});
      }

      window.location.reload();
    }




  },
};
</script>

<template>
  <header class="main-header shadow-sm bg-white d-flex align-items-center px-3">
    
    <!-- Zone Gauche (Logo App ou Titre si besoin) -->
    <div class="header-brand me-auto">
       <!-- <img src="@/assets/logo.svg" height="30" alt="Logo" /> -->
    </div>

    <!-- Zone Droite : Sélecteur de Fournisseur (Mode Admin Simulation) -->
    <div v-if="isAdmin" class="admin-controls d-flex align-items-center">
      
      <div class="simulation-label me-3 d-none d-md-block">
        <b-badge variant="light" class="text-primary border px-2 py-1">
          <i class="fas fa-user-shield me-1"></i> Mode Simulation
        </b-badge>
      </div>

      <!-- Sélecteur d'Identité (Workspace Picker) -->
      <div 
        v-if="simulatedSupplier && simulatedSupplier.id" 
        class="workspace-switcher" 
        @click="openSupplierModal"
      >
        <div class="workspace-avatar">
          <img
            v-if="simulatedSupplier.logo && simulatedSupplier.logo !== 'null'"
            :src="'/api/image/get/' + simulatedSupplier.logo"
            alt="Logo"
          />
          <div v-else class="avatar-placeholder">
            {{ simulatedSupplier.name ? simulatedSupplier.name.charAt(0) : 'S' }}
          </div>
        </div>

        <div class="workspace-details d-none d-sm-block">
          <div class="workspace-name">{{ simulatedSupplier.name || "-" }}</div>
          <div class="workspace-sub">MF: {{ simulatedSupplier.taxNumber || "-" }}</div>
        </div>

      </div>

      <!-- Bouton si aucun n'est sélectionné -->
      <b-button 
        v-else 
        variant="primary" 
        size="sm" 
        class="btn-select-workspace shadow-sm px-3" 
        @click="openSupplierModal"
      >
        <i class="fas fa-exchange-alt me-2"></i> Sélectionner Client
      </b-button>
    </div>

    <!-- MODAL : Liste des fournisseurs -->
    <b-modal
      v-model="showSupplierModal"
      hide-header
      hide-footer
      centered
      size="lg"
      modal-class="modern-modal"
      body-class="p-0"
    >
      <div class="modal-header-custom p-4 border-bottom d-flex justify-content-between align-items-center">
        <div>
          <h5 class="mb-1 font-weight-bold">Choisir un compte fournisseur</h5>
          <p class="text-muted small mb-0">Simuler l'interface pour un client spécifique</p>
        </div>
        <b-link class="text-muted" @click="showSupplierModal = false">
          <i class="fas fa-times"></i>
        </b-link>
      </div>

      <div class="p-0 bg-light" style="max-height: 70vh; overflow-y: auto;">
        <SuppliersTable 
          :suppliers="supplierList" 
          :loading="supplierListIsBusy"
          :page="mainPageModel.page" 
          :pageSize="mainPageModel.pageSize" 
          :total="mainPageModel.total"
          :withActions="false"
          :withCreationDate="false"
          :cardStyle="true"
          @update:page="onPageChange"
          @update:pageSize="onPageSizeChange"
          @update:row="handleSetSimulatedSupplier"
        />
      </div>
    </b-modal>

  </header>
</template>

<style scoped>
.main-header {
  height: 70px;
  border-bottom: 1px solid #f1f5f9;
  position: sticky;
  top: 0;
  z-index: 98;
}

/* Identity Switcher Style */
.workspace-switcher {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  background-color: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.workspace-switcher:hover {
  background-color: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateY(-1px);
}

.workspace-avatar {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.workspace-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatar-placeholder {
  color: white;
  font-weight: 700;
  font-size: 14px;
}

.workspace-details {
  margin-left: 10px;
  text-align: left;
  line-height: 1.2;
}

.workspace-name {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e293b;
  max-width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.workspace-sub {
  font-size: 0.7rem;
  color: #64748b;
  font-weight: 500;
}

/* Simulation Badge */
:deep(.badge-light) {
  background-color: #eef2ff;
  color: #4f46e5;
  font-weight: 600;
  border-color: #e0e7ff !important;
}

/* Button style */
.btn-select-workspace {
  border: none;
  border-radius: 10px;
  font-weight: 600;
}

.btn-select-workspace:hover {
  background-color: #4338ca;
}

/* Modal Customization */
:deep(.modern-modal .modal-content) {
  z-index: 100;
  border: none;
  border-radius: 16px;
  overflow: hidden;
}

.modal-header-custom h5 {
  color: #1e293b;
}

/* Hamburger menu styles from your original code (optional) */
.hamburger {
  width: 24px;
  height: 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
}
.hamburger span {
  height: 2px;
  background: #64748b;
  border-radius: 2px;
}
</style>
